import { type CommonRequestFn } from "@marketplace/http";

import { ENDPOINTS } from "@/constants/endpoints";
import { httpClient } from "@/http";
import type { GetVoucherListRequestDto } from "@/modules/voucher/dtos/get-voucher-list-request-dto";
import type { GetVoucherListResponseDto } from "@/modules/voucher/dtos/get-voucher-list-response-dto";

import type { ApproveVoucherRequestDto } from "../dtos/approve-voucher-request-dto";
import type { ApproveVoucherResponseDto } from "../dtos/approve-voucher-response-dto";
import type { CreateVoucherRequestDto } from "../dtos/create-voucher-request-dto";
import type { CreateVoucherResponseDto } from "../dtos/create-voucher-response-dto";
import type { DeleteVoucherRequestDto } from "../dtos/delete-voucher-request-dto";
import type { GetVoucherDetailRequestDto } from "../dtos/get-voucher-detail-request-dto";
import type { GetVoucherDetailResponseDto } from "../dtos/get-voucher-detail-response-dto";

type VoucherServiceContract = {
  createVoucher: CommonRequestFn<
    CreateVoucherRequestDto,
    CreateVoucherResponseDto
  >;
  getVoucherList: CommonRequestFn<
    GetVoucherListRequestDto,
    GetVoucherListResponseDto
  >;
  getVoucherDetail: CommonRequestFn<
    GetVoucherDetailRequestDto,
    GetVoucherDetailResponseDto
  >;
  approveVoucher: CommonRequestFn<
    ApproveVoucherRequestDto,
    ApproveVoucherResponseDto
  >;
  deleteVoucher: CommonRequestFn<DeleteVoucherRequestDto, { success: boolean }>;
};

export const VoucherService: VoucherServiceContract = {
  createVoucher: ({ payload, options }) =>
    httpClient
      .post(ENDPOINTS.VOUCHER.CREATE, {
        ...options,
        json: payload
      })
      .json<CreateVoucherResponseDto>(),

  getVoucherList: async ({ payload, options }) =>
    httpClient
      .get(ENDPOINTS.VOUCHER.LIST, {
        searchParams: payload,
        ...options
      })
      .json<GetVoucherListResponseDto>(),

  getVoucherDetail: async ({ payload, options }) =>
    httpClient
      .get(ENDPOINTS.VOUCHER.DETAIL(payload.voucherId), {
        ...options
      })
      .json<GetVoucherDetailResponseDto>(),

  approveVoucher: ({ payload, options }) =>
    httpClient
      .put(ENDPOINTS.VOUCHER.APPROVAL(payload.voucherId), {
        ...options,
        json: payload
      })
      .json<ApproveVoucherResponseDto>(),

  deleteVoucher: async ({ payload, options }) =>
    httpClient
      .delete(ENDPOINTS.VOUCHER.DELETE(payload.voucherId), {
        ...options
      })
      .json<{ success: boolean }>()
};
